import styled from 'styled-components';
import { FieldInfoText } from './components/CreateBookingForm/CreateDetailedBookingForm.styles';

export const ModalContent = styled.div`
  min-width: 60rem;
`;

export const InfoFieldTextContainer = styled(FieldInfoText)`
  margin-bottom: 1rem;
  margin-left: 11.5rem;
`;
